import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { changeSupportStatus, getSupports } from "../actions/adminActions";

const initialState = {
  supports: null,
};

export const reportsSlice = createSlice({
  name: "supportsSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSupports.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.supports = payload.data;
        } else if (!payload.success) {
          toast.error(payload?.message);
        }
      })
      .addCase(changeSupportStatus.fulfilled, (state, { payload }) => {
        if (payload.success) {
          state.supports = state.supports?.map((sup) =>
            sup?._id == payload?.data?._id ? payload?.data : sup
          );
          toast.success(payload.message);
        } else if (!payload.success) {
          toast.error(payload?.message);
        }
      });
  },
});

export default reportsSlice.reducer;
